import React from "react";
import { DialogWrapper } from "../common/Dialog";
import { DialogProps } from "../../types/dialog-types";
import { getTigerResource, tigerFormat } from "../../utils/tigerResource";

export interface VersionInfoDialogProps extends DialogProps {
  turbineName?: string;
  onDownload?: () => void;
  onCancel?: () => void;
}

export function VersionInfoDialog({
  open,
  onClose,
  turbineName = "turbine",
  onDownload,
  onCancel,
}: VersionInfoDialogProps) {
  const handleDownload = () => {
    onDownload?.();
    onClose();
  };

  const handleCancel = () => {
    onCancel?.();
    onClose();
  };

  return (
    <DialogWrapper
      open={open}
      onClose={onClose}
      title={tigerFormat(getTigerResource("TIGER_VERSION_CHECK_TITLE"), turbineName)}
      width={440}
    >
      <div className="dialog-body">
        <div className="dialog-icon-row">
          <span className="dialog-icon dialog-icon-warning" aria-label={getTigerResource("TIGER_QUERY_SEV_WARN")}>&#9888;</span>
          <span className="dialog-icon-text">
            {getTigerResource("TIGER_VERSION_CHECK_MSG")}
          </span>
        </div>
      </div>
      <div className="dialog-buttons">
        <button className="dialog-btn" onClick={handleDownload}>{getTigerResource("TIGER_RES_DOWNLOAD")}</button>
        <button className="dialog-btn" onClick={handleCancel}>{getTigerResource("TIGER_RES_CANCEL")}</button>
      </div>
    </DialogWrapper>
  );
}
